import React from 'react';
import PropTypes from 'prop-types';
import Message from 'components/Message';
import MessageContent from 'components/messages/MessageContent';
import MessageButton from 'components/messages/MessageButton';

const SendCodeFailure = ({ onDismiss, onResendCodeClick }) => (
  <Message
    type="error"
    onDismiss={onDismiss}
    message={(
      <MessageContent>
        Oops that didn&apos;t work.
        <MessageButton onClick={onResendCodeClick}>Resend code?</MessageButton>
      </MessageContent>
    )}
  />
);

SendCodeFailure.displayName = 'SendCodeSuccess';

SendCodeFailure.propTypes = {
  onDismiss: Message.propTypes.onDismiss.isRequired,
  onResendCodeClick: PropTypes.func.isRequired,
};

export default SendCodeFailure;
